export default __webpack_public_path__ + "static/media/announcement_2.0cab3d8f.png";